/**
 * @brief alert modal
 * @details
 * @author hyekyoungKang
 * @date 2024-06-14
 * @version 0.0.1
 */
import React from "react";
import styles from "./AlertModal.module.scss";
import CommonModal from "./common/CommonModal";

const AlertModal = ({ title }) => {
  return (
    <CommonModal padding={"32px"}>
      <div className={styles.container}>
        <div className={styles.container__title}>
          <span className={styles.container__titleTxt}>{title}</span>
        </div>
      </div>
    </CommonModal>
  );
};

export default AlertModal;
